/**
 * Add the directive "v-click-outside", which calls a method
 * when the user clicks outside the current element (or its children).
 *
 * Usage:
 * import clickOutside from 'tools/directives/click-outside'
 * directives: { clickOutside }
 * <div v-click-outside="onClickOutside"></div>
 */

function createCallback(element, bindingValue) {
  return (event) => {
    if (!element.contains(event.target) && typeof bindingValue === 'function') {
      bindingValue(event)
    }
  }
}

export default {
  bind: function(element, binding) {
    element.__vueClickOutside__ = createCallback(element, binding.value)
    document.body.addEventListener('click', element.__vueClickOutside__)
  },
  componentUpdated: function(element, binding) {
    if (binding.value !== binding.oldValue) {
      document.body.removeEventListener('click', element.__vueClickOutside__)
      element.__vueClickOutside__ = createCallback(element, binding.value)
      document.body.addEventListener('click', element.__vueClickOutside__)
    }
  },
  unbind: function(element, binding) {
    document.body.removeEventListener('click', element.__vueClickOutside__)
    element.__vueClickOutside__ = null
  }
}
